import React from "react";
interface props {
  stepNumber: string;
  icon: React.ReactNode;
}

export const NumberedIconCard = ({ stepNumber, icon }: props) => {
  return (
    <div className="bg-brand-lightBlue h-[100px] w-[120px] pt-[27px] pb-[19px] clip-path-topLeftPolygon">
      <p className="pl-[33px] font-openSans font-semibold text-web-body-sm leading-[10px] text-brand-textGrey">
        {stepNumber}
      </p>
      {/* Icon */}
      <div className="pl-[43px] mt-[9px]">{icon}</div>
    </div>
  );
};
